import { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
} from "@mui/material";
import MDBox from "../MDBox";
import MDInput from "../MDInput";
import * as React from "react";
import { useForm } from "react-hook-form";
import { RegexCode } from "../../config/validationRegex";

function UpdateModal({
    open,
    onClose,
    onUpdate,
    nodeCount,
    setNodeCount,
}) {
    const {
        reset,
        register,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const [isUpdating, setisUpdating] = useState(false);
    const [gkeNodeCount, setGkeNodeCount] = useState(0)

    const handleUpdate = async () => {
        setisUpdating(true);
        const res=await onUpdate();
        setisUpdating(false);
        onClose();
    };

    useEffect(() => {
        onLoadHandler()
    }, [nodeCount, open, close])

    const onLoadHandler = () => {
        setGkeNodeCount(nodeCount)
    }

    const onCloseHandler=()=>{
        onClose()
        reset()
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Update GKE Node Count</DialogTitle>
            <MDBox component="form" role="form">
                <DialogContent>
                    <Typography variant="body1">
                        <MDBox mb={2}>
                            <MDInput
                                placeholder={`Current Node Count ${Number(nodeCount)}`}
                                type="number"
                                variant="standard"
                                fullWidth
                                id="nodeCount"
                                {...register("nodeCount", {
                                    required: true,
                                    pattern: RegexCode.numbersRegex,
                                    onChange: (e) => setNodeCount(e.target.value)
                                })}
                                error={Boolean(errors.nodeCount)}
                                helperText={errors.nodeCount ? "Invalid Node count" : ""}
                            />
                        </MDBox>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCloseHandler} disabled={isUpdating}>
                        Cancel
                    </Button>
                    <Button onClick={handleUpdate} disabled={isUpdating} style={{ color: "red" }}>
                        Update
                    </Button>
                </DialogActions>
            </MDBox>
        </Dialog>
    );
}

export default UpdateModal;
